export const SUCCESS_MESSAGE_CATEGORY_KEY = 'message' as const;
export const SUCCESS_MESSAGE_COMPONENT_KEY = 'successMessage' as const;
